<div class="jep-layout">
  @if (getDebugModeFromUrl()) {
    <div class="layout-debug-info" data-testid="layout-debug-info">
      @if (getAccountIdDisplay()) {
        <div class="layout-debug-info__item">
          <span class="layout-debug-info__label layout-debug-info__label--account">accountId:</span>
          <span class="layout-debug-info__value">{{ getAccountIdDisplay() }}</span>
        </div>
      }
      @if (getViewIdDisplay()) {
        <div class="layout-debug-info__item">
          <span class="layout-debug-info__label layout-debug-info__label--view">viewId:</span>
          <span class="layout-debug-info__value">{{ getViewIdDisplay() }}</span>
        </div>
      }
      @if (getPageIdDisplay()) {
        <div class="layout-debug-info__item">
          <span class="layout-debug-info__label layout-debug-info__label--page">pageId:</span>
          <span class="layout-debug-info__value">{{ getPageIdDisplay() }}</span>
        </div>
      }
      @if (getLayoutId()) {
        <div class="layout-debug-info__item">
          <span class="layout-debug-info__label layout-debug-info__label--layout">layoutId:</span>
          <span class="layout-debug-info__value">{{ getLayoutId() }}</span>
        </div>
      }
      <div class="layout-debug-info__item">
        <span class="layout-debug-info__label layout-debug-info__label--theme">themeId:</span>
        <span class="layout-debug-info__value">{{ themeIdDisplay() }}</span>
      </div>
    </div>
  }
  <div class="grid-stack" #gridStackHost></div>
</div>
